import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getMyLimitedExpressTicket = async (id) => {
  let response;
  try {
    response = await apiWrapper("GET", `/mfitt/limited_express_tickets/${id}`);
    console.log("getMyLimitedExpressTicket response.data :>> ", response.data);
    store.commit("MFITT/setMyLimitedExpressTicket", response.data);
  } catch (err) {
    console.log('ERROR"" getMyLimitedExpressTicket():', err);
    throw err;
  }
  return response.data;
};
